import {
  StoredFilterRequest,
  StoredFiltersRequest,
  StoredFiltersRequestDelete,
  UpdateStoredFilterRequest
} from "../entities/Filter/StoredFiltersRequest";
import {
  StoredFilterItem,
  StoredFiltersResponse
} from "../entities/Filter/StoredFiltersResponse";
import RequestService from "./RequestService";
import CompanyService from "./CompanyService";

// The backend truncates stored filter names longer than this.
export const STORED_FILTER_NAME_MAX_LENGTH = 50;

class StoredFiltersService {
  public static getList(
    request: StoredFiltersRequest
  ): Promise<Error | StoredFiltersResponse> {
    return RequestService.post("/storedfilter/list", {
      report: request.report
    });
  }
  public static getListByReport(
    request: StoredFiltersRequest
  ): StoredFiltersResponse {
    const allFilters = CompanyService.getStoredFilters() ?? [];
    const list: StoredFilterItem[] = allFilters
      .filter((f) => f.Report === (request.report as any))
      .map((f) => ({
        Report: f.Report as any,
        Name: f.Name,
        UserID: f.UserID,
        Private: f.Private,
        Filter: f.Filter,
        Created: f.Created,
        StoredFilterID: f.StoredFilterID,
        StoredFilterID_ref: f.StoredFilterID_ref
      }));
    return { list };
  }
  public static set(
    request: StoredFilterRequest
  ): Promise<Error | { refreshlists: number; Id: number }> {
    return RequestService.post("/storedfilter/set", { ...request });
  }
  public static delete(
    request: StoredFiltersRequestDelete
  ): Promise<Error | unknown> {
    return RequestService.post("/storedfilter/delete", { ...request });
  }
  public static update(
    request: UpdateStoredFilterRequest
  ): Promise<Error | unknown> {
    return RequestService.post("/storedfilter/updatefilter", { ...request });
  }
}

export default StoredFiltersService;
